import { Observable, Subject } from 'rxjs';

export class ImageTool {
  public static resizeFile$(
    file: File,
    maxWidth: number,
    maxHeight: number,
    quality: number,
  ): Observable<File> {
    const observer = new Subject<File>();
    const img = new Image();
    const reader = new FileReader();
    reader.onload = (e) => {
      img.src = e.target?.result as string;
    };
    img.onload = () => {
      let { width, height } = img;
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = width * ratio;
        height = height * ratio;
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          if (blob) {
            observer.next(new File([blob], file.name, { type: 'image/jpeg' }));
          } else {
            observer.next(file);
          }
        },
        'image/jpeg',
        quality,
      );
    };
    img.onerror = (error) => {
      console.error(error);
      observer.next(file);
    };
    reader.readAsDataURL(file);
    return observer;
  }
}
